/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomfunneljoins3Inputs */

const en_liveroomfunneljoins3 = /** @type {(inputs: Liveroomfunneljoins3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checked in`)
};

const de_liveroomfunneljoins3 = /** @type {(inputs: Liveroomfunneljoins3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingecheckt`)
};

/**
* | output |
* | --- |
* | "Checked in" |
*
* @param {Liveroomfunneljoins3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomfunneljoins3 = /** @type {((inputs?: Liveroomfunneljoins3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomfunneljoins3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomfunneljoins3(inputs)
	return de_liveroomfunneljoins3(inputs)
});
export { liveroomfunneljoins3 as "liveRoomFunnelJoins" }